import { Fragment } from 'react';

import CheckmarkIcon from '@zola/zola-ui/src/components/SvgIcons/Checkmark';

import cx from 'classnames';

import styles from './conditionalCheckmark.module.less';

type FlexibleSummaryOptionProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  visible: boolean;
};

export const ConditionalCheckmark: React.FC<FlexibleSummaryOptionProps> = ({
  visible,
  className,
  children,
  ...rest
}) => {
  if (visible) {
    return (
      <div className={cx(styles.conditionalCheckmark, className)} {...rest}>
        <CheckmarkIcon />
        {children}
      </div>
    );
  }
  return <Fragment />;
};
